<template>
  <div class="container">
    <div class="conmonContent">
      <div class="w1600">
        <keep-alive>
          <search search_type="faq"></search>
        </keep-alive>

        <!-- 主体列表内容 -->
        <div class="proDocument proQuestion">
          <div class="conmonDocument bd10">
            <ul>
              <li
                :class="['d-flex j-sb a-center', { haveImg: item.cover }]"
                v-for="(item, index) in FAQVOList"
                :key="index"
              >
                <figure class="pointer pr" v-if="item.cover">
                  <a
                    @click="goToPage('/questionDetail?id='+item.id)"
                    href="javascript:;"
                    class="ab"
                  ></a>
                  <img :src="item.cover" class="w100" alt="" />
                </figure>
                <div class="pdLeft">
                  <h3 class="font18 pdf d-flex">
                    <a
                      @click="goToPage('/questionDetail?id='+item.id)"
                      class="link"
                      href="javascript:;"
                      >{{ item.title }}</a
                    ><span  class="font-light  cor999">{{ item.releaseDate }}</span>
                  </h3>
                  <p class="cor999 font-light line-sm">
                    {{ item.description }}
                  </p>
                  <div class="tagList d-flex f-wrap">
                    <i
                      class="font14"
                      v-for="(item2, index2) in item.subGroup
                        ? item.subGroup.split(',')
                        : []"
                      :key="index2"
                      >{{ item2 }}</i
                    >
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="10"
              layout="prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Search组件
import search from "./component/search.vue";
export default {
  name: "ProductQuestion",
  components: {
    search,
  },
  data() {
    return {
      // 常见问题
      FAQVOList: [],
      // 分页
      pagination: {
        contentType: "faq",
        pageNo: 1,
        pageSize: 10,
        productId: "",
      },
      // 数量
      total: 0,
    };
  },

  created() {
    this.pagination.productId = this.$route.query.productId;
    // 获取文档
    this.getFAQVOList();
  },

  methods: {
    // 页面跳转
    goToPage(path, query = {}) {
      this.$router.push({
        path,
        query,
      });
    },

    // 获取文档
    getFAQVOList() {
      this.$axios
        .post(`product/otherPage`, this.pagination)
        .then((res) => {
          let data = res.data;
          this.FAQVOList = data.list;
          this.total = data.total;
        })
        .catch((err) => {});
    },

    // 点击翻页
    handleCurrentChange(current) {
      this.pagination.pageNo = current;
      // 更新
      this.getFAQVOList();
    },
  },
};
</script>

<style lang="less" scoped>
.proQuestion {
  figure {
    width: 2rem;
  }
}

.proDocument {
  .pdLeft {
    width: 100%;
    p {
      margin-top: 0.1rem;
    }
    .tagList {
      margin-top: 0.2rem;
    }
  }
  .conmonDocument {
    ul li {
      &.haveImg {
        h3 {
          padding-left: 0;
          background: none !important;
        }
        .pdLeft {
          width: calc(100% - 2.2rem);
        }
      }
      h3 {
        width: 100%;
        justify-content: space-between;
		&.pdf{
			background: url(@/assets/Icons/questionIcon.png) no-repeat left center;
			background-size: auto 0.18rem;
			min-height: 0.18rem;
		}
        span {
          flex: 0 0 auto;
          padding-left: 2em;
		  font-size: 0.8em;
		font-weight: normal;
        }
        a {
          flex: 1 1 auto;
          overflow: hidden;
        }
      }
    }
  }
  @media (max-width: 640px) {
    .conmonDocument {
      ul li {
        &.haveImg {
          flex-direction: column;
          .pdLeft,
          figure {
            width: 100%;
          }
          .pdLeft {
            margin-top: 0.2rem;
          }
        }
      }
    }
  }
}

.conmonDocument {
  padding: 0.3rem;

  ul li {
    padding: 0.25rem 0;
    &:not(:last-child) {
      border-bottom: solid 1px #f1f1f1;
    }
    h3 {
      width: 85%;
    }
  }
}
</style>
